import { useStore } from 'zustand';

import { Bot, botStore } from '@mygpt/app/bot/store';

export const useBot = () => {
  const store = useStore(botStore);

  return {
    ...store,
    botId: (store.botId || Bot.getDefaultBotId()) ?? '',
  };
};
